import { makeAutoObservable } from 'mobx';

export class MIDI {
  selectedMIDIInput = null;
  selectedMIDIOutput = null;
  selectedInputChannel = 0;  // MIDI channel 0-15
  selectedOutputChannel = 0;

  availableMIDIInputs = [];
  availableMIDIOutputs = [];
  isBroadcasting = false;

  constructor(store) {
    this.store = store;
    this.senderId = crypto.randomUUID()
    makeAutoObservable(this);

    if (navigator.requestMIDIAccess) {
      navigator.requestMIDIAccess().then((midiAccess) => {
        this.availableMIDIInputs = Array.from(midiAccess.inputs.values());
        this.availableMIDIOutputs = Array.from(midiAccess.outputs.values());

        console.log('MIDI Inputs:', this.availableMIDIInputs);
        console.log('MIDI Outputs:', this.availableMIDIOutputs);
      });
    } else {
      console.warn('WebMIDI is not supported in this browser.');
    }
  }

  selectMIDIInput(deviceId) {
    const device = this.availableMIDIInputs.find(d => d.id === deviceId);
    if (device && (!this.selectedMIDIOutput || this.selectedMIDIOutput.id !== deviceId)) {
      this.selectedMIDIInput = device;
    } else {
      console.warn('Invalid input selection or same as output device');
    }
  }

  selectMIDIOutput(deviceId) {
    const device = this.availableMIDIOutputs.find(d => d.id === deviceId);
    if (device && (!this.selectedMIDIInput || this.selectedMIDIInput.id !== deviceId)) {
      this.selectedMIDIOutput = device;
    } else {
      console.warn('Invalid output selection or same as input device');
    }
  }

  setInputChannel(channel) {
    if (channel >= 0 && channel <= 15) {
      this.selectedInputChannel = channel;
    }
  }

  setOutputChannel(channel) {
    if (channel >= 0 && channel <= 15) {
      this.selectedOutputChannel = channel;
    }
  }

  startBroadcasting() {
    if (!this.selectedMIDIInput) return;

    this.isBroadcasting = true;

    const midiMessageDict = {
      command: "midi_message",
      room: this.store.selectedRoom.id,
    };

    this.selectedMIDIInput.onmidimessage = (event) => {
      const [status, data1, data2] = event.data;
      const command = status & 0xf0;
      const channel = status & 0x0f;

      if (channel !== this.selectedInputChannel) return; // Filter by input channel

      if (command === 0x90 && data2 !== 0) {
        this.store.sendMessage({
          ...midiMessageDict,
          midi_data: { type: "NoteOn", data: data1, sender_id: this.senderId },
        });
      } else if (command === 0x80 || (command === 0x90 && data2 === 0)) {
        this.store.sendMessage({
          ...midiMessageDict,
          midi_data: { type: "NoteOff", data: data1, sender_id: this.senderId },
        });
      }
    };
  }

  sendMIDIMessageOut(message) {
    if (!this.selectedMIDIOutput) {
      console.warn("No MIDI output device selected");
      return;
    }

    if (message.sender_id === this.senderId) return;

    let data;
    const channel = this.selectedOutputChannel & 0x0f;
    if (message.type === "NoteOn") {
      data = [0x90 | channel, message.data, 127];
    } else if (message.type === "NoteOff") {
      data = [0x80 | channel, message.data, 0];
    } else {
      console.warn("Unknown MIDI message type:", message.type);
      return;
    }

    this.selectedMIDIOutput.send(data);
  }
}
